import { ArrowRightIcon } from "@phosphor-icons/react";
import type { FlightType } from "../lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContext";
import { clsx } from "clsx";

type Params = {
  flight: FlightType;
  className?: string;
};

function FlightOriginAndDestination({ flight, className }: Params) {
  const segments = flight?.segments || [];

  return (
    <div
      className={clsx("flex items-center gap-1 text-base font-bold", className)}
    >
      {segments[0]?.departure.city.name}
      <ArrowRightIcon size={16} className="rtl:-scale-x-100" />
      {segments[segments.length - 1]?.arrival.city.name}
    </div>
  );
}

export default FlightOriginAndDestination;
